import { useState } from 'react';
import { useVantifyContext } from 'integrations-vantify-context-providers';
import {
  getAllSiteTenants,
  SiteTenantListResponse,
} from 'integrations-vantify-client-services';
import { FetchSiteTenantsParams } from './types';
import { useVantifyBase } from '../useVantifyBase';
import { VantifyOperation, hookMessages } from '../common';

export function useVantifySiteTenants() {
  const { auth } = useVantifyContext();
  const { loading, error, execute, setError } = useVantifyBase();
  const [siteTenants, setSiteTenants] = useState<SiteTenantListResponse | null>(
    null
  );

  const fetchSiteTenants = async ({
    userId,
    siteId,
  }: FetchSiteTenantsParams) => {
    if (!auth) {
      setError(e => ({
        ...e,
        [VantifyOperation.FETCH_SITE_TENANTS]:
          hookMessages.error_FETCH_SITE_TENANTS,
      }));

      return null;
    }

    const response = await execute(
      VantifyOperation.FETCH_SITE_TENANTS,
      () => getAllSiteTenants(auth, userId, siteId),
      hookMessages.error_FETCH_SITE_TENANTS
    );

    if (response?.data) {
      setSiteTenants(response.data);

      return response.data;
    }

    return null;
  };

  return {
    siteTenants,
    loading,
    error,
    fetchSiteTenants,
  };
}
